// import { useEffect, useState } from "react";
// import { Link } from "react-router-dom";
// import "./Hero.css";

// // 👉 images import from folder
// import img1 from "../images/img1.jpg";
// import img2 from "../images/img2.jpg";
// import img3 from "../images/img3.jpg";
// import img4 from "../images/img4.jpg";

// export default function App() {
//   const images = [img1, img2, img3, img4];
//   const [index, setIndex] = useState(0);

//   useEffect(() => {
//     const timer = setInterval(() => {
//       setIndex((prev) => (prev + 1) % images.length);
//     }, 3000);

//     return () => clearInterval(timer);
//   }, [images.length]);

//   return (
//     <div className="page">

//       {/* LEFT SIDE */}
//       <div className="left">

//         <Link to="/director-desk" className="left-link">
//           <div className="left-title-box">
//             ग्रंथालय संचालकांचा अभिप्राय (From Director Desk)
//           </div>
//         </Link>

//         <Link to="/event-clips" className="left-link">
//           <div className="left-box single">
//             कार्यक्रमांचे चित्रफीत
//             <span>(Event Clips)</span>
//           </div>
//         </Link>

//         <Link to="/available-books" className="left-link">
//           <div className="left-box single">
//             उपलब्ध पुस्तके
//             <span>(Available Books)</span>
//           </div>
//         </Link>

//         <Link to="/periodicals" className="left-link">
//           <div className="left-box single">
//             नियतकालिके व मासिके
//             <span>(Periodicals & Magazines)</span>
//           </div>
//         </Link>

//         <Link to="/newspapers" className="left-link">
//           <div className="left-box single">
//             उपलब्ध वर्तमानपत्रे
//             <span>(Available Newspapers)</span>
//           </div>
//         </Link>

//         <Link to="/reference-books" className="left-link">
//           <div className="left-box single">
//             संदर्भग्रंथ
//             <span>(Reference Books)</span>
//           </div>
//         </Link>

//       </div>

//       {/* MIDDLE IMAGE SLIDER */}
//       <div className="center">
//         <img src={images[index]} alt="Library Event" />
//       </div>

//       {/* RIGHT */}
//       <div className="right">
//         <div className="right-title">
//           वृत्त व अध्यायवत माहिती (News and Updates)
//         </div>

//         <div className="news-ticker">
//           <div className="news-move">

//             <div className="news-item">
//               <a href="#">उत्सव कवितांचा – कोजागिरी पौर्णिमा कार्यक्रम</a>
//               <p>
//                 पुणे नगर वाचन मंदिर येथे कोजागिरी पौर्णिमेच्या निमित्ताने
//                 आयोजित कार्यक्रमात रसिकांनी मोठ्या प्रमाणावर सहभाग घेतला.
//               </p>
//             </div>

//             <div className="news-item">
//               <a href="#">नवीन ग्रंथ संग्रह उपलब्ध</a>
//               <p>
//                 विविध विषयांवरील नवीन पुस्तके ग्रंथालयात उपलब्ध
//                 करून देण्यात आली आहेत.
//               </p>
//             </div>

//             <div className="news-item">
//               <a href="#">वाचनालय सभासद नोंदणी सुरू</a>
//               <p>
//                 नवीन सभासद नोंदणी प्रक्रिया सुरू असून इच्छुकांनी
//                 कार्यालयाशी संपर्क साधावा.
//               </p>
//             </div>

//           </div>
//         </div>
//       </div>

//     </div>
//   );
// }




import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "./Hero.css";

// 👉 images import from folder
import img1 from "../images/img1.jpg";
import img2 from "../images/img2.jpg";
import img3 from "../images/img3.jpg";
import img4 from "../images/img4.jpg";

export default function HeroComponent() {
  const images = [img1, img2, img3, img4];
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setIndex((prev) => (prev + 1) % images.length);
    }, 3000);

    return () => clearInterval(timer);
  }, [images.length]);

  return (
    <div className="page">

      {/* LEFT SIDE - सर्व लिंक्स स्वतंत्र पेजेस कडे नेतील */}
      <div className="left">

        <Link to="/director-desk" className="left-link">
          <div className="left-title-box">
            ग्रंथालय संचालकांचा अभिप्राय (From Director Desk)
          </div>
        </Link>

        <Link to="/eventclips" className="left-link">
          <div className="left-box single">
            कार्यक्रमांचे चित्रफीत <span>(Event Clips)</span>
          </div>
        </Link>

        <Link to="/available-books" className="left-link">
          <div className="left-box single">
            उपलब्ध पुस्तके <span>(Available Books)</span>
          </div>
        </Link>

        <Link to="/periodicals" className="left-link">
          <div className="left-box single">
            नियतकालिके व मासिके <span>(Periodicals & Magazines)</span>
          </div>
        </Link>

        <Link to="/newspapers" className="left-link">
          <div className="left-box single">
            उपलब्ध वर्तमानपत्रे <span>(Available Newspapers)</span>
          </div>
        </Link>

        <Link to="/reference-books" className="left-link">
          <div className="left-box single">
             हस्तलिखिते <span>(Reference Books)</span>
          </div>
        </Link>

      </div>

      {/* MIDDLE IMAGE SLIDER */}
      <div className="center">
        <img src={images[index]} alt="Library Event" />
      </div>

      {/* RIGHT SIDE - NEWS TICKER */}
      <div className="right">
        <div className="right-title">
          वृत्त व अद्ययावत माहिती (News and Updates) {/* व्याकरणानुसार 'अध्यायवत' चे 'अद्ययावत' केले आहे */}
        </div>

        <div className="news-ticker">
          <div className="news-move">
            <div className="news-item">
              <a href="#">उत्सव कवितांचा – कोजागिरी पौर्णिमा कार्यक्रम</a>
              <p>
                पुणे नगर वाचन मंदिर येथे कोजागिरी पौर्णिमेच्या निमित्ताने
                आयोजित कार्यक्रमात रसिकांनी मोठ्या प्रमाणावर सहभाग घेतला.
              </p>
            </div>

            <div className="news-item">
              <a href="#">नवीन ग्रंथ संग्रह उपलब्ध</a>
              <p>
                विविध विषयांवरील नवीन पुस्तके ग्रंथालयात उपलब्ध
                करून देण्यात आली आहेत.
              </p>
            </div>

            <div className="news-item">
              <a href="#">वाचनालय सभासद नोंदणी सुरू</a>
              <p>
                नवीन सभासद नोंदणी प्रक्रिया सुरू असून इच्छुकांनी
                कार्याल्याशी संपर्क साधावा.
              </p>
            </div>
          </div>
        </div>
      </div>

    </div>
  );
}